export default __webpack_public_path__ + "static/media/germany.MOV.95a8bd6f.zip";